import { navigateNativeBack } from './native-navigation.js';
import { Capacitor } from '@capacitor/core';
export const nativeApp = typeof __NATIVE_APP_CONFIG__ === 'undefined' ? null : __NATIVE_APP_CONFIG__;
export const isNative = () => Capacitor.isNativePlatform();
export async function initialiseNativeApp(router) {
  if (!nativeApp) return;
  const root = document.documentElement;
  root.classList.add('native-app');
  root.style.setProperty('--bs-primary', nativeApp.primary);
  root.style.setProperty('--app-primary', nativeApp.primary);
  const rgb = nativeApp.primary.slice(1).match(/../g).map(value => parseInt(value,16)).join(', ');
  root.style.setProperty('--bs-primary-rgb', rgb);
  document.title = nativeApp.appName;
  if (!isNative()) return;
  const { App } = await import('@capacitor/app');
  const { Browser } = await import('@capacitor/browser');
  await App.addListener('backButton', () => navigateNativeBack(router, nativeApp));
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href]');
    if(!anchor) return;
    const url = new URL(anchor.href, location.href);
    if(['https:','http:'].includes(url.protocol) && url.origin !== location.origin) {
      event.preventDefault();
      Browser.open({url:url.href});
    }
  });
}
